import React from 'react'

const SolidityCompiler = () => (
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.45" d="M5.85986 0L3.98904 3.42895H0.25L2.11953 0H5.85986" fill="currentColor"/>
    <path opacity="0.6" d="M3.98914 3.42895H7.72949L5.85996 0H2.11963L3.98914 3.42895Z" fill="currentColor"/>
    <path opacity="0.8" d="M2.11953 6.85657L3.98904 3.42895L2.11953 0L0.25 3.42895L2.11953 6.85657Z" fill="currentColor"/>
    <path opacity="0.45" d="M2.1377 12L4.00852 8.57104H7.74888L5.87804 12H2.1377Z" fill="currentColor"/>
    <path opacity="0.6" d="M4.00841 8.57104H0.268066L2.13759 12H5.87793L4.00841 8.57104Z" fill="currentColor"/>
    <path opacity="0.8" d="M5.87808 5.14343L4.00854 8.57105L5.87808 12L7.7489 8.57105L5.87808 5.14343Z" fill="currentColor"/>
  </svg>
)
export default SolidityCompiler;